import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '山童科技'
          },
          // children: [
          //   {
          //     path: '/homeDetail',
          //     name: 'homeDetail',
          //     component: resolve => require(['@/view/HomeDetail'], resolve),
          //     meta: { title: '内容介绍' }
          //   }
          // ],
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '项目介绍'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '合作模式'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '项目介绍丨智慧大棚'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '数字平台'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '智慧社区'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '政务平台'
          }
        },{
          path: '/shangwu',
          name: 'shangwu',
          component: resolve => require(['@/view/shangwu'], resolve),
          meta: {
            title: '商务平台'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '掌田驿站'
          }
        },
        {
          path: '/homeDetail',
          name: 'homeDetail',
          component: resolve => require(['@/view/HomeDetail'], resolve),
          meta: {
            title: '公司简介'
          }
        },
        {
          path: '/homeTwo',
          name: 'homeTwo',
          component: resolve => require(['@/view/homeTwo'], resolve),
          meta: {
            title: '政策护航'
          }
        },
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js